import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'

import { Pencil } from '@/components/icons'
import { PageCard, PageLayout } from '@/components/ui/page'

import { dateId } from '@/libs/utils/format'

import { itemCategoryDetail } from '@/features/item/api'

export const Route = createFileRoute('/_app/inventory/category/$id/')({
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()
	const { category } = useSuspenseQuery(itemCategoryDetail.qry({ id })).data

	return (
		<PageLayout>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/master', 'Master Bahan Dasar'],
					['/inventory/category', 'Kategori'],
					[Route.fullPath, category.name],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header
					title="Daftar Master Item"
					actions={
						<PageCard.HeaderAction asChild>
							<Link from={Route.fullPath} to="/inventory/category/$id/edit">
								<Pencil /> Edit
							</Link>
						</PageCard.HeaderAction>
					}
				/>
				<PageCard.ContentRow title="Nama Kategori" value={category.name} />
				<PageCard.ContentRow
					title="Aktif"
					value={category.isActive ? 'Ya' : 'Tidak'}
				/>
				<PageCard.ContentRow
					title="Created At"
					value={dateId(category.createdAt)}
				/>
				<PageCard.ContentRow
					title="Updated At"
					value={dateId(category.updatedAt)}
				/>
			</PageCard.Root>
		</PageLayout>
	)
}
